module.exports = __webpack_public_path__ + "assets/img/dyz.38f608bf.png";